export const extractIntegersFromString = (text: string): number[] => {
   const numbersAsString: string[] = text.match(/\d+/g) || [];

   return numbersAsString.map(Number);
};

export const sanitizeNumbersFromString = (text: string): string => {
   const textWithoutNumbers: string[] = [];

   text.split(/\d+/g).map((t: string) => {
      textWithoutNumbers.push(t);
   });

   return textWithoutNumbers.join('').trim();
};

// Used mostly to fix IE 11 bug where left to mark characters are added to result of Intl format function
// https://stackoverflow.com/questions/25574963/ies-tolocalestring-has-strange-characters-in-results
export const removeNonPrintableCharacters = (text: string) =>
   text.split('')
      .filter(t => t !== String.fromCharCode(8206) && t !== String.fromCharCode(8207))
      .join('');
